/** @graphql cc **/

import gql from 'graphql-tag';

export const NativeCollabProviderQuery = gql`
	query NativeCollabProviderQuery($accountId: ID, $shouldIncludePermissionType: Boolean = false) {
		user: confluence_atlassianUser(id: $accountId) {
			id
			displayName
			photos {
				value
				isPrimary
			}

			confluence @include(if: $shouldIncludePermissionType) {
				permissionType
			}
		}
	}
`;
